import { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AuthContext from "../context/auth";

const RootLayout = () => {
  return <Outlet />;
};

export default RootLayout;
